<template>
  <lottie v-if="animation" :options="animationOptions" @animCreated="handleAnimation" />
</template>

<script>
import lottie from 'vue-lottie'
export default {
  components: {
    lottie
  },
  props: {
    animation: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      defaultAnimationOptions: {
        loop: true,
        autoplay: true
      },
      anim: null
    }
  },
  computed: {
    animationOptions() {
      return Object.assign(this.defaultAnimationOptions, this.animation)
    }
  },
  beforeDestroy () {
  },
  methods: {
    handleAnimation (anim) {
      this.anim = anim
    }
  }
}
</script>

<style scoped>

</style>
